const DAYOFF_TYPES = [{
        value: '1',
        display: '特休',
    },
    {
        value: '2',
        display: '事假'
    },
    {
        value: '3',
        display: '病假',
    },
    {
        value: '4',
        display: '生理假'
    },
    {
        value: '5',
        display: '喪假'
    },
    {
        value: '6',
        display: '婚假'
    },
    {
        value: '7',
        display: '產假'
    },
    {
        value: '8',
        display: '流產假'
    },
    {
        value: '9',
        display: '育嬰假'
    },
    {
        value: '10',
        display: '家庭照護假'
    },
]

export { DAYOFF_TYPES };